import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { SectionHeader, Pill } from "@/components/Brand";
import { Download } from "lucide-react";

export default function CandidatePurchases() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/candidate/purchases").then((r) => setItems(r.data));
  }, []);
  const download = async (p) => {
    const r = await api.get(`/candidate/export/ward/${p.ward_id}`, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${p.ward_name}_report.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <div>
      <SectionHeader eyebrow="History" title="My purchased reports" />
      <div className="space-y-2">
        {items.length === 0 && <div className="text-sm text-slate-500">No reports purchased yet.</div>}
        {items.map((p) => (
          <div key={p.id} className="wi-card p-4 flex items-center justify-between" data-testid={`purchase-${p.id}`}>
            <div>
              <div className="font-semibold text-slate-900">{p.ward_name}</div>
              <div className="text-xs font-mono text-slate-500">{p.created_at?.slice(0, 10)} · ₹{p.amount_inr} · {p.method}</div>
            </div>
            <div className="flex items-center gap-2">
              <Pill tone={p.status === "active" ? "green" : "red"}>{p.status}</Pill>
              {p.status === "active" && (
                <>
                  <Link
                    to={`/candidate/wards/${p.ward_id}`}
                    className="text-xs px-3 py-1.5 bg-slate-900 text-white rounded-md"
                    data-testid={`open-${p.id}`}
                  >
                    Open
                  </Link>
                  <button
                    onClick={() => download(p)}
                    data-testid={`download-${p.id}`}
                    className="text-xs px-3 py-1.5 border border-slate-200 rounded-md inline-flex items-center gap-1"
                  >
                    <Download size={12} /> CSV
                  </button>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
